// The redesigned look of the projects page (the project list and the project
// dashboard at /project/<projectKey>), in the project bank's colours and
// corners. It is opt-in: each user turns it on with the "Uusi ulkoasu" switch
// on the project dashboard (ProjectPageDesignSwitch), and the choice is an
// attribute of their UserSetting record.

/** UserSetting attribute holding the choice (a boolean). */
export const PROJECT_PAGE_REDESIGN_SETTING = 'projectPageRedesign';

/**
 * What a user who has never chosen sees (no attribute, or anything but a
 * boolean in it): the classic look. Only an explicit `true` shows the new one.
 */
export const PROJECT_PAGE_REDESIGN_DEFAULT = false;
